import { ReturnBlock } from "../ReturnBlock";
import { VoidBlock } from "../VoidBlock";

/**
 * Internal use.
 */
export class ConsoleLogBlock extends VoidBlock {
    input;

    /**
     * Constructor
     * @param input array of return blocks being printed
     */
    constructor(id: string, input: ReturnBlock[]) {
        super(id)
        console.log("this is the input", input)
        this.input = input;
    }

    *evalBlock(varEnv: Map<string, any>){
        this.input.forEach(inp => {
            let val = inp.evalBlock(varEnv);
            console.log(val);
        });
        yield;

    }
}